import React, { useEffect } from 'react'
import '../styles/About.css'

function About() {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="about-page">

      <div className="about-inner">

        <div className="about-left">
          <span className="about-label">ჩვენს შესახებ</span>
          <h1 className="about-title">Your Hood</h1>
          <p className="about-sub">
            ონლაინ მაღაზია Your Hood მოღვაწეობას იწყებს 2020 წელს და მას შემდეგ
            აქტიურად გთავაზობთ ბრენდული ტანსაცმლის, ფეხსაცმლის, ჩანთების და
            აქსესუარების უახლეს კოლექციას.
          </p>
          <div className="about-line" />
        </div>

        <div className="about-right">

          <div className="about-card">
            <div className="about-card-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
                <circle cx="12" cy="9" r="2.5" />
              </svg>
            </div>
            <div className="about-card-info">
              <span className="about-card-label">დაარსდა</span>
              <span className="about-card-value">2020 წელს</span>
            </div>
          </div>

          <div className="about-card">
            <div className="about-card-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>
            <div className="about-card-info">
              <span className="about-card-label">ჩვენი მისია</span>
              <span className="about-card-value">ხარისხი და სტილი</span>
            </div>
          </div>

          <div className="about-card">
            <div className="about-card-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="3" width="20" height="14" rx="2" />
                <path d="M8 21h8M12 17v4" />
              </svg>
            </div>
            <div className="about-card-info">
              <span className="about-card-label">შეძენა</span>
              <span className="about-card-value">ონლაინ და შეკვეთით</span>
            </div>
          </div>

          <div className="about-card">
            <div className="about-card-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </div>
            <div className="about-card-info">
              <span className="about-card-label">ელ-ფოსტა</span>
            <a 
  href="mailto:yourhoodshop@gmail.com" 
  className="about-card-value" 
  style={{ textDecoration: 'none' }}
>
  yourhoodshop@gmail.com
</a>
            </div>
          </div>

        </div>
      </div>

      <div className="about-bg-text">ABOUT</div>
    </div>
  )
}

export default About